import _ from "lodash";
import deck from "./deck";

const shuffleDeck = (theDeck) => {
  return _.shuffle(theDeck);
};

const deckOfCards = () => {
  return shuffleDeck(deck);
};

function dealCards(numPlayers, dealer) {
  let shuffledDeck = shuffleDeck(deck);
  const numCardsPerDeal = 3;
  let dealRound1 = [];
  let dealRound2 = [];

  // deals first three cards to each player
  for (let i = 0; i < numPlayers; i++) {
    const hand = [];
    for (let j = 0; j < numCardsPerDeal; j += numCardsPerDeal) {
      const deal = shuffledDeck.splice(0, numCardsPerDeal);

      hand.push(...deal);
    }

    dealRound1.push(hand);
  }

  // deals second three cards to each player
  for (let i = 0; i < numPlayers; i++) {
    const hand2 = [];
    for (let j = 0; j < numCardsPerDeal; j += numCardsPerDeal) {
      const deal = shuffledDeck.splice(0, numCardsPerDeal);
      hand2.push(...deal);
    }
    dealRound2.push(hand2);
  }

  // combines the two deals of 3 cards to make one hand of 6 cards for each player
  const finalHand = dealRound1.map((deal1, i) => {
    return [...deal1, ...dealRound2[i]];
  });

  // sorts the hands by suit, and then by value within each suit
  finalHand.map((hand) => {
    return hand.sort((a, b) => {
      if (a.suit < b.suit) return -1;
      if (a.suit > b.suit) return 1;

      if (a.details.value < b.details.value) return -1;
      if (a.details.value > b.details.value) return 1;

      return 0;
    });
  });

  // sort the array to take into consideration who the dealer is. if the dealer is player2, then player 1 would get the third array of cards, faceUp

  const finalOrganizedHands = rearrangeHands(finalHand, dealer);

  const assignedFinalHands = assignCardsOwners(finalOrganizedHands);

  return assignedFinalHands;
}

// this arranges the array based on the dealer
const rearrangeHands = (finalHands, dealers) => {
  const modifiedHands = [...finalHands];

  if (dealers === 1) {
    const removedHands = modifiedHands.splice(0, 3);
    modifiedHands.push(...removedHands);
  } else if (dealers === 2) {
    const removedHands = modifiedHands.splice(0, 2);
    modifiedHands.push(...removedHands);
  } else if (dealers === 3) {
    const removedHands = modifiedHands.splice(0, 1);
    modifiedHands.push(...removedHands);
  }

  return modifiedHands;
};

const assignCardsOwners = (cardHands) => {
  const cardOwners = cardHands.map((hands, i) => {
    return hands.map((hand) => {
      if (i + 1 === 1) {
        return {
          ...hand,
          details: { ...hand.details, owner: `P${i + 1}`, faceUp: true },
        };
      }

      return {
        ...hand,
        details: { ...hand.details, owner: `P${i + 1}`, faceUp: false },
      };
    });
  });
  return cardOwners;
};

const assignInitialDealer = (numPlayers) => {
  return Math.floor(Math.random() * numPlayers) + 1;
};

const updateCardProperties = (card, trump, newTrick) => {
  let updatedCard = { ...card };

  if (card.suit === trump) {
    updatedCard = { ...card, details: { ...card.details, trump: true } };
  }
  // newTrick is "" before anyone has led this trick - nothing should be
  // dimmed yet in that case (the leader can play anything).
  if (newTrick && card.suit !== newTrick && card.suit !== trump) {
    updatedCard = { ...updatedCard, shouldDarken: true };
  }

  return updatedCard;
};

const sortCardsByTrump = (a, b) => {
  if (a.details.trump && !b.details.trump) {
    return 1;
  } else if (!a.details.trump && b.details.trump) {
    return -1;
  } else {
    return 0;
  }
};

const updateCardPropertiesAfter = (
  card,
  trump,
  person,
  newTrick,
  includeTrickLead,
  includeTrump
) => {
  let updatedCard = { ...card };

  const allCardsNotTrumpOrTrickSuit = person?.hand.every(
    (card) => card.suit !== trump && card.suit !== newTrick
  );

  const hasTrumpCards = person?.hand.some((card) => card.suit === trump);
  const hasNewTrickCards = person?.hand.some((card) => card.suit === newTrick);

  if (newTrick !== trump && hasTrumpCards && !hasNewTrickCards) {
    updatedCard = { ...updatedCard, shouldDarken: false };
  } else if (allCardsNotTrumpOrTrickSuit) {
    updatedCard = { ...updatedCard, shouldDarken: false };
  } else if (
    !hasTrumpCards &&
    newTrick !== trump &&
    hasNewTrickCards &&
    card.suit !== newTrick
  ) {
    updatedCard = { ...updatedCard, shouldDarken: true };
  } else if (
    card.suit !== newTrick &&
    card.suit !== trump &&
    (hasNewTrickCards || hasTrumpCards)
  ) {
    updatedCard = { ...updatedCard, shouldDarken: true };
  }

  return updatedCard;
};

let initialState = [
  {
    player: "P1",
    isTurn: false,
    hand: [],
    wonTricks: [],
    isDealer: false,
    bid: null,
    isPitcher: false,
  },
  {
    player: "P2",
    isTurn: false,
    hand: [],
    wonTricks: [],
    isDealer: false,
    bid: null,
    isPitcher: false,
  },
  {
    player: "P3",
    isTurn: false,
    hand: [],
    wonTricks: [],
    isDealer: false,
    bid: null,
    isPitcher: false,
  },
  {
    player: "P4",
    isTurn: false,
    hand: [],
    wonTricks: [],
    isDealer: false,
    bid: null,
    isPitcher: false,
  },
];

export {
  shuffleDeck,
  dealCards,
  assignInitialDealer,
  updateCardProperties,
  deckOfCards,
  sortCardsByTrump,
  initialState,
  updateCardPropertiesAfter,
};
